import React, { Component } from "react";
import { Link } from "react-router-dom";
import ModalLayout from "../Modal/ModalLayout";
import "./style/stepProgress.css";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import moment from "moment";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

class StepProgress extends Component {
  state = {
    login_done: 0,
    enter_details_done: 0,
    payment_initiation_done: 0,
    payment_complete: 0,
    isActive: false,
    modalShow: false,
    appointment_data: null,
    createdAt: null,
  };
  userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );

  componentWillMount() {
    const self = this;
    afterLoginApiAxios({
      method: "post",
      url: "/patient/patient_consult_tracking",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        instant_consult_id: localStorage.getItem("instantConsultId"),
      },
    })
      .then((res) => {
        if (res.data.statusCode === 200) {
          const login_done = res.data.data.login_done;
          const enter_details_done = res.data.data.enter_details_done;
          const payment_initiation_done = res.data.data.enter_details_done;
          const payment_complete = res.data.data.payment_complete;
          const appointment = res.data.data.appointment_data;
          const time = res.data.data.created_at;
          const payment_failed = res.data.data.payment_failed;
          self.setState({
            login_done: login_done,
            enter_details_done: enter_details_done,
            payment_initiation_done: payment_initiation_done,
            payment_complete: payment_complete,
            appointment_data: appointment,
            createdAt: time,
            payment_failed: payment_failed,
          });
          if (payment_complete == 1) {
            self.setState({ isActive: true });
            // self.props.props.history.push({
            //     pathname:'/doctor/video',
            //     state:{app_id:self.state.appointment_data}
            // })
            if (self?.props?.location?.pathname === "/doctor/video") {
              self.props.history.push({
                pathname: "/doctor/video",
                state: { app_id: self.state.appointment_data, is_audio: false },
              });
            }
            //clearInterval(myVar);
          }
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }

  componentDidMount() {
    const self = this;
    var myVar = setInterval(myTimer, 10000);
    function myTimer() {
      self.setState((prevState) => {
        return { count: prevState.count + 1 };
      });
      afterLoginApiAxios({
        method: "post",
        url: "/patient/patient_consult_tracking",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          instant_consult_id: localStorage.getItem("instantConsultId"),
        },
      })
        .then((res) => {
          if (res.data.statusCode === 200) {
            const login_done = res.data.data.login_done;
            const enter_details_done = res.data.data.enter_details_done;
            const payment_initiation_done = res.data.data.enter_details_done;
            const payment_complete = res.data.data.payment_complete;
            const appointment = res.data.data.appointment_data;
            self.setState({
              login_done: login_done,
              enter_details_done: enter_details_done,
              payment_initiation_done: payment_initiation_done,
              payment_complete: payment_complete,
              appointment_data: appointment,
            });
            if (payment_complete == 1) {
              self.setState({ isActive: true });
              clearInterval(myVar);
              if (self?.props?.location?.pathname === "/doctor/video") {
                self.props.history.push({
                  pathname: "/doctor/video",
                  state: {
                    app_id: self.state.appointment_data,
                    is_audio: false,
                  },
                });
              }
            }
          }
        })
        .catch((err) => {
          C2CConsole.log(err);
        });
      let time = moment(self.state.createdAt, "YYYY-MM-DD HH:mm:ss");
      let currentTime = moment(new Date());
      let diff = moment.duration(currentTime.diff(time));
      if (diff.asMinutes() >= 15) {
        clearInterval(myVar);
        self.setState({ modalShow: true });
        if (
          self.state.appointment_data &&
          self.state.appointment_data.id !== null
        ) {
          afterLoginApiAxios({
            method: "post",
            url: "/public/cancel-appointment-request",
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              appointment_id: self.state.appointment_data.id,
              doctor_id: this.userId,
              reason: "Testing",
            },
          })
            .then((res) => {
              if (res.status == 200) {
                if (res.data.statusCode === 516) {
                  swal({
                    title: "Unable to cancel appointment",
                    text: res.data.message,
                    icon: "error",
                    button: "Okay",
                  });
                }
              }
            })
            .catch((err) => C2CConsole.log(err));
        }
        afterLoginApiAxios({
          method: "post",
          url: "/doctor/instant_consultation_status",
          headers: {
            authorization: localStorage.getItem("id_token"),
          },
          data: {
            instant_consult_id: localStorage.getItem("instantConsultId"),
            is_cancelled: true,
          },
        })
          .then((res) => {
            C2CConsole.log(res);
          })
          .catch((err) => C2CConsole.log(err));
      }
    }
  }

  closeModal = () => {
    this.setState({ modalShow: false });
  };

  render() {
    return (
      <div className="step_progress_box">
        <div className="step_progress_heading">
          <h6>Patient will join the consultation shortly </h6>
          <p className="patient_message">
            Your instant consultation will start once your patient joins. The
            duration of consult will be 15 mins. Patient might take some time to
            make payment and join the consultation, please{" "}
            <b>DO NOT CLOSE THIS WINDOW.</b>
          </p>
        </div>
        <ul>
          <li
            className={
              this.state.login_done == 1 ? "doneStatus" : "cuurentStatus"
            }
          >
            <p className="progress_value">1</p>
            <p className="progress_text">Login</p>
          </li>
          {this.state.login_done == 1 ? (
            <li
              className={
                this.state.login_done == 1 && this.state.enter_details_done == 1
                  ? "doneStatus"
                  : "cuurentStatus"
              }
            >
              <p className="progress_value">2</p>
              <p className="progress_text">Enter Details</p>
            </li>
          ) : (
            <li className="">
              <p className="progress_value">2</p>
              <p className="progress_text">Enter Details</p>
            </li>
          )}
          {this.state.login_done == 1 && this.state.enter_details_done == 1 ? (
            <li
              className={
                this.state.login_done == 1 &&
                this.state.enter_details_done == 1 &&
                this.state.payment_initiation_done == 1
                  ? "doneStatus"
                  : "cuurentStatus"
              }
            >
              <p className="progress_value">3</p>
              <p className="progress_text">Initiate Payment</p>
            </li>
          ) : (
            <li className="">
              <p className="progress_value">3</p>
              <p className="progress_text">Initiate Payment</p>
            </li>
          )}

          {this.state.login_done == 1 &&
          this.state.enter_details_done == 1 &&
          this.state.payment_initiation_done == 1 ? (
            <li
              className={
                this.state.login_done == 1 &&
                this.state.enter_details_done == 1 &&
                this.state.payment_initiation_done == 1 &&
                this.state.payment_complete == 1
                  ? "doneStatus"
                  : "cuurentStatus"
              }
            >
              <p className="progress_value">4</p>
              <p className="progress_text">Complete Payment</p>
            </li>
          ) : (
            <li className="">
              <p className="progress_value">4</p>
              <p className="progress_text">Complete Payment</p>
            </li>
          )}
        </ul>

        <div className="jion_metting_btn_box">
          <Link
            to={{
              pathname:
                this.doctorClinicAssociation &&
                this.doctorClinicAssociation === "false"
                  ? "/doctor/video"
                  : "/clinic/video",
              state: { app_id: this.state.appointment_data, is_audio: false },
            }}
            href="#"
            className={`btn btn_format ${
              this.state.isActive == true ? "isActive" : "notClickable "
            }`}
          >
            Join Now
          </Link>
        </div>

        <div>
          <ModalLayout show={this.state.modalShow} onHide={this.closeModal} />
        </div>
      </div>
    );
  }
}

export default withRouter(StepProgress);
